import Repository from "./Repository";

export default {
  // Get All architect Companies
  getArchitectCompanies() {
    return Repository.get(`/admin/architect_company`);
  },

  getArchitectCompany(id) {
    return Repository.get(`/admin/architect_company/${id}`);
  },

  createArchitectCompany(payload) {
    return Repository.post(`/admin/architect_company`, payload);
  },

  updateArchitectCompany(payload) {
    const id = payload.id;
    delete payload.id;
    return Repository.put(`/admin/architect_company/${id}`, payload);
  },

  deleteArchitectCompany(id) {
    return Repository.delete(`/admin/architect_company/${id}`);
  },

  getArchitectsByCompany(id) {
    return Repository.get(`/admin/architect_company/${id}/architect`);
  },

  getCompanyArchitect(payload) {
    return Repository.get(
      `/admin/architect_company/${payload.id}/architect/${payload.email}`
    );
  },

  updateArchitect(payload) {
    const email = payload.email;
    const companyId = payload.companyId;

    delete payload.email;
    delete payload.companyId;

    return Repository.put(
      `/admin/architect_company/${companyId}/architect/${email}`,
      payload
    );
  },

  deleteArchitect(payload) {
    return Repository.delete(
      `/admin/architect_company/${payload.id}/architect/${payload.email}`
    );
  },

  inviteArchitect(payload) {
    const id = payload.id;
    delete payload.id;
    return Repository.post(
      `/admin/architect_company/${id}/architect/invite`,
      payload
    );
  }
};
